// packages block
import { Avatar, Box, IconButton, Menu, MenuItem } from '@mui/material';
import { FC, useContext, useRef, useState } from 'react';
// others block
import { PrimaryDots } from '../../assets/images';
import { AppContext, AuthContext } from '../../context';
import { ActionType } from '../../context/AppContextReducer';
import { ExternalUsersMenuProps } from '../../interfaceTypes';
import { anchorOrigin, menuPaperStyles, transformOrigin } from '../../theme/styleConstants';
import { ExternalUserActionType } from '../externalUsers/externalUserReducer';

export const ExternalUsersMenu: FC<ExternalUsersMenuProps> = ({ currentExternalUser, externalUserDispatch }): JSX.Element => {
  const [open, setOpen] = useState<boolean>(false);
  const { dispatch, isDeleteOpen, isEdit } = useContext(AppContext)
  const { isAdmin } = useContext(AuthContext)
  const { id } = currentExternalUser || {}
  const caseId = id || ""

  const handleClick = () => setOpen(!open);

  const handleClose = () => setOpen(false);

  const anchorRef = {
    [caseId]: useRef<HTMLButtonElement>(null),
  };

  const handleDeleteModal = () => {
    handleClose();
    dispatch({ type: ActionType.SET_IS_DELETE_OPEN, isDeleteOpen: !isDeleteOpen })
    externalUserDispatch({ type: ExternalUserActionType.SET_CURRENT_EXTERNAL_USER, currentExternalUser: currentExternalUser })
  }

  const handleEditModal = () => {
    handleClose()
    externalUserDispatch({
      type: ExternalUserActionType.SET_CURRENT_EXTERNAL_USER,
      currentExternalUser: currentExternalUser
    })
    dispatch({ type: ActionType.SET_IS_EDIT, isEdit: !isEdit })
  }

  return (
    <Box>
      <IconButton
        ref={anchorRef[caseId]}
        id={`long-button-${caseId}`}
        aria-controls={`long-menu-${caseId}`}
        aria-haspopup="true"
        onClick={handleClick}
      >
        <Avatar sx={{ bgcolor: 'transparent' }}>
          <PrimaryDots />
        </Avatar>
      </IconButton>

      <Menu
        id={`long-menu-${caseId}`}
        anchorEl={anchorRef[caseId].current}
        open={open}
        anchorOrigin={anchorOrigin}
        transformOrigin={transformOrigin}
        onClose={handleClose}
        PaperProps={menuPaperStyles}
      >
        <MenuItem onClick={handleEditModal}>View</MenuItem>
        {isAdmin &&
          <MenuItem onClick={handleDeleteModal} color='red'>Delete</MenuItem>
        }
      </Menu>
    </Box>
  );
};
